/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
import * as $protobuf from "protobufjs/minimal";

const $Reader = $protobuf.Reader, $util = $protobuf.util;

const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const zoom = $root.zoom = (() => {

    const zoom = {};

    zoom.mail = (function() {

        const mail = {};

        mail.MIMEPart = (function() {

            function MIMEPart(p) {
                this.headers = [];
                this.multiValHeaders = [];
                if (p)
                    for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                        if (p[ks[i]] != null)
                            this[ks[i]] = p[ks[i]];
            }

            MIMEPart.prototype.headers = $util.emptyArray;
            MIMEPart.prototype.body = null;
            MIMEPart.prototype.attachment = null;
            MIMEPart.prototype.children = null;
            MIMEPart.prototype.multiValHeaders = $util.emptyArray;

            let $oneOfFields;

            Object.defineProperty(MIMEPart.prototype, "content", {
                get: $util.oneOfGetter($oneOfFields = ["body", "attachment", "children"]),
                set: $util.oneOfSetter($oneOfFields)
            });

            MIMEPart.decode = function decode(r, l) {
                if (!(r instanceof $Reader))
                    r = $Reader.create(r);
                var c = l === undefined ? r.len : r.pos + l, m = new $root.zoom.mail.MIMEPart();
                while (r.pos < c) {
                    var t = r.uint32();
                    switch (t >>> 3) {
                    case 1:
                        if (!(m.headers && m.headers.length))
                            m.headers = [];
                        m.headers.push($root.zoom.mail.MIMEPart.Header.decode(r, r.uint32()));
                        break;
                    case 2:
                        m.body = r.bytes();
                        break;
                    case 3:
                        m.attachment = $root.zoom.mail.MIMEPart.Attachment.decode(r, r.uint32());
                        break;
                    case 4:
                        m.children = $root.zoom.mail.MIMEPart.Children.decode(r, r.uint32());
                        break;
                    case 5:
                        if (!(m.multiValHeaders && m.multiValHeaders.length))
                            m.multiValHeaders = [];
                        m.multiValHeaders.push($root.zoom.mail.MIMEPart.AddrHeader.decode(r, r.uint32()));
                        break;
                    default:
                        r.skipType(t & 7);
                        break;
                    }
                }
                return m;
            };

            MIMEPart.fromObject = function fromObject(d) {
                if (d instanceof $root.zoom.mail.MIMEPart)
                    return d;
                var m = new $root.zoom.mail.MIMEPart();
                if (d.headers) {
                    if (!Array.isArray(d.headers))
                        throw TypeError(".zoom.mail.MIMEPart.headers: array expected");
                    m.headers = [];
                    for (var i = 0; i < d.headers.length; ++i) {
                        if (typeof d.headers[i] !== "object")
                            throw TypeError(".zoom.mail.MIMEPart.headers: object expected");
                        m.headers[i] = $root.zoom.mail.MIMEPart.Header.fromObject(d.headers[i]);
                    }
                }
                if (d.body != null) {
                    if (typeof d.body === "string")
                        $util.base64.decode(d.body, m.body = $util.newBuffer($util.base64.length(d.body)), 0);
                    else if (d.body.length)
                        m.body = d.body;
                }
                if (d.attachment != null) {
                    if (typeof d.attachment !== "object")
                        throw TypeError(".zoom.mail.MIMEPart.attachment: object expected");
                    m.attachment = $root.zoom.mail.MIMEPart.Attachment.fromObject(d.attachment);
                }
                if (d.children != null) {
                    if (typeof d.children !== "object")
                        throw TypeError(".zoom.mail.MIMEPart.children: object expected");
                    m.children = $root.zoom.mail.MIMEPart.Children.fromObject(d.children);
                }
                if (d.multiValHeaders) {
                    if (!Array.isArray(d.multiValHeaders))
                        throw TypeError(".zoom.mail.MIMEPart.multiValHeaders: array expected");
                    m.multiValHeaders = [];
                    for (var i = 0; i < d.multiValHeaders.length; ++i) {
                        if (typeof d.multiValHeaders[i] !== "object")
                            throw TypeError(".zoom.mail.MIMEPart.multiValHeaders: object expected");
                        m.multiValHeaders[i] = $root.zoom.mail.MIMEPart.AddrHeader.fromObject(d.multiValHeaders[i]);
                    }
                }
                return m;
            };

            MIMEPart.toObject = function toObject(m, o) {
                if (!o)
                    o = {};
                var d = {};
                if (o.arrays || o.defaults) {
                    d.headers = [];
                    d.multiValHeaders = [];
                }
                if (m.headers && m.headers.length) {
                    d.headers = [];
                    for (var j = 0; j < m.headers.length; ++j) {
                        d.headers[j] = $root.zoom.mail.MIMEPart.Header.toObject(m.headers[j], o);
                    }
                }
                if (m.body != null && m.hasOwnProperty("body")) {
                    d.body = o.bytes === String ? $util.base64.encode(m.body, 0, m.body.length) : o.bytes === Array ? Array.prototype.slice.call(m.body) : m.body;
                    if (o.oneofs)
                        d.content = "body";
                }
                if (m.attachment != null && m.hasOwnProperty("attachment")) {
                    d.attachment = $root.zoom.mail.MIMEPart.Attachment.toObject(m.attachment, o);
                    if (o.oneofs)
                        d.content = "attachment";
                }
                if (m.children != null && m.hasOwnProperty("children")) {
                    d.children = $root.zoom.mail.MIMEPart.Children.toObject(m.children, o);
                    if (o.oneofs)
                        d.content = "children";
                }
                if (m.multiValHeaders && m.multiValHeaders.length) {
                    d.multiValHeaders = [];
                    for (var j = 0; j < m.multiValHeaders.length; ++j) {
                        d.multiValHeaders[j] = $root.zoom.mail.MIMEPart.AddrHeader.toObject(m.multiValHeaders[j], o);
                    }
                }
                return d;
            };

            MIMEPart.prototype.toJSON = function toJSON() {
                return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
            };

            MIMEPart.AddrHeader = (function() {

                function AddrHeader(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                AddrHeader.prototype.name = "";
                AddrHeader.prototype.display = "";
                AddrHeader.prototype.email = "";

                AddrHeader.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.zoom.mail.MIMEPart.AddrHeader();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.name = r.string();
                            break;
                        case 2:
                            m.display = r.string();
                            break;
                        case 3:
                            m.email = r.string();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                AddrHeader.fromObject = function fromObject(d) {
                    if (d instanceof $root.zoom.mail.MIMEPart.AddrHeader)
                        return d;
                    var m = new $root.zoom.mail.MIMEPart.AddrHeader();
                    if (d.name != null) {
                        m.name = String(d.name);
                    }
                    if (d.display != null) {
                        m.display = String(d.display);
                    }
                    if (d.email != null) {
                        m.email = String(d.email);
                    }
                    return m;
                };

                AddrHeader.toObject = function toObject(m, o) {
                    if (!o)
                        o = {};
                    var d = {};
                    if (o.defaults) {
                        d.name = "";
                        d.display = "";
                        d.email = "";
                    }
                    if (m.name != null && m.hasOwnProperty("name")) {
                        d.name = m.name;
                    }
                    if (m.display != null && m.hasOwnProperty("display")) {
                        d.display = m.display;
                    }
                    if (m.email != null && m.hasOwnProperty("email")) {
                        d.email = m.email;
                    }
                    return d;
                };

                AddrHeader.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return AddrHeader;
            })();

            MIMEPart.Header = (function() {

                function Header(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                Header.prototype.name = "";
                Header.prototype.value = "";

                Header.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.zoom.mail.MIMEPart.Header();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.name = r.string();
                            break;
                        case 2:
                            m.value = r.string();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                Header.fromObject = function fromObject(d) {
                    if (d instanceof $root.zoom.mail.MIMEPart.Header)
                        return d;
                    var m = new $root.zoom.mail.MIMEPart.Header();
                    if (d.name != null) {
                        m.name = String(d.name);
                    }
                    if (d.value != null) {
                        m.value = String(d.value);
                    }
                    return m;
                };

                Header.toObject = function toObject(m, o) {
                    if (!o)
                        o = {};
                    var d = {};
                    if (o.defaults) {
                        d.name = "";
                        d.value = "";
                    }
                    if (m.name != null && m.hasOwnProperty("name")) {
                        d.name = m.name;
                    }
                    if (m.value != null && m.hasOwnProperty("value")) {
                        d.value = m.value;
                    }
                    return d;
                };

                Header.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Header;
            })();

            MIMEPart.Attachment = (function() {

                function Attachment(p) {
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                Attachment.prototype.index = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
                Attachment.prototype.size = $util.Long ? $util.Long.fromBits(0,0,true) : 0;
                Attachment.prototype.encoding = "";
                Attachment.prototype.filename = "";

                Attachment.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.zoom.mail.MIMEPart.Attachment();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            m.index = r.uint64();
                            break;
                        case 2:
                            m.size = r.uint64();
                            break;
                        case 3:
                            m.encoding = r.string();
                            break;
                        case 4:
                            m.filename = r.string();
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                Attachment.fromObject = function fromObject(d) {
                    if (d instanceof $root.zoom.mail.MIMEPart.Attachment)
                        return d;
                    var m = new $root.zoom.mail.MIMEPart.Attachment();
                    if (d.index != null) {
                        if ($util.Long)
                            (m.index = $util.Long.fromValue(d.index)).unsigned = true;
                        else if (typeof d.index === "string")
                            m.index = parseInt(d.index, 10);
                        else if (typeof d.index === "number")
                            m.index = d.index;
                        else if (typeof d.index === "object")
                            m.index = new $util.LongBits(d.index.low >>> 0, d.index.high >>> 0).toNumber(true);
                    }
                    if (d.size != null) {
                        if ($util.Long)
                            (m.size = $util.Long.fromValue(d.size)).unsigned = true;
                        else if (typeof d.size === "string")
                            m.size = parseInt(d.size, 10);
                        else if (typeof d.size === "number")
                            m.size = d.size;
                        else if (typeof d.size === "object")
                            m.size = new $util.LongBits(d.size.low >>> 0, d.size.high >>> 0).toNumber(true);
                    }
                    if (d.encoding != null) {
                        m.encoding = String(d.encoding);
                    }
                    if (d.filename != null) {
                        m.filename = String(d.filename);
                    }
                    return m;
                };

                Attachment.toObject = function toObject(m, o) {
                    if (!o)
                        o = {};
                    var d = {};
                    if (o.defaults) {
                        if ($util.Long) {
                            var n = new $util.Long(0, 0, true);
                            d.index = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else
                            d.index = o.longs === String ? "0" : 0;
                        if ($util.Long) {
                            var n = new $util.Long(0, 0, true);
                            d.size = o.longs === String ? n.toString() : o.longs === Number ? n.toNumber() : n;
                        } else
                            d.size = o.longs === String ? "0" : 0;
                        d.encoding = "";
                        d.filename = "";
                    }
                    if (m.index != null && m.hasOwnProperty("index")) {
                        if (typeof m.index === "number")
                            d.index = o.longs === String ? String(m.index) : m.index;
                        else
                            d.index = o.longs === String ? $util.Long.prototype.toString.call(m.index) : o.longs === Number ? new $util.LongBits(m.index.low >>> 0, m.index.high >>> 0).toNumber(true) : m.index;
                    }
                    if (m.size != null && m.hasOwnProperty("size")) {
                        if (typeof m.size === "number")
                            d.size = o.longs === String ? String(m.size) : m.size;
                        else
                            d.size = o.longs === String ? $util.Long.prototype.toString.call(m.size) : o.longs === Number ? new $util.LongBits(m.size.low >>> 0, m.size.high >>> 0).toNumber(true) : m.size;
                    }
                    if (m.encoding != null && m.hasOwnProperty("encoding")) {
                        d.encoding = m.encoding;
                    }
                    if (m.filename != null && m.hasOwnProperty("filename")) {
                        d.filename = m.filename;
                    }
                    return d;
                };

                Attachment.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Attachment;
            })();

            MIMEPart.Children = (function() {

                function Children(p) {
                    this.parts = [];
                    if (p)
                        for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                            if (p[ks[i]] != null)
                                this[ks[i]] = p[ks[i]];
                }

                Children.prototype.parts = $util.emptyArray;

                Children.decode = function decode(r, l) {
                    if (!(r instanceof $Reader))
                        r = $Reader.create(r);
                    var c = l === undefined ? r.len : r.pos + l, m = new $root.zoom.mail.MIMEPart.Children();
                    while (r.pos < c) {
                        var t = r.uint32();
                        switch (t >>> 3) {
                        case 1:
                            if (!(m.parts && m.parts.length))
                                m.parts = [];
                            m.parts.push($root.zoom.mail.MIMEPart.decode(r, r.uint32()));
                            break;
                        default:
                            r.skipType(t & 7);
                            break;
                        }
                    }
                    return m;
                };

                Children.fromObject = function fromObject(d) {
                    if (d instanceof $root.zoom.mail.MIMEPart.Children)
                        return d;
                    var m = new $root.zoom.mail.MIMEPart.Children();
                    if (d.parts) {
                        if (!Array.isArray(d.parts))
                            throw TypeError(".zoom.mail.MIMEPart.Children.parts: array expected");
                        m.parts = [];
                        for (var i = 0; i < d.parts.length; ++i) {
                            if (typeof d.parts[i] !== "object")
                                throw TypeError(".zoom.mail.MIMEPart.Children.parts: object expected");
                            m.parts[i] = $root.zoom.mail.MIMEPart.fromObject(d.parts[i]);
                        }
                    }
                    return m;
                };

                Children.toObject = function toObject(m, o) {
                    if (!o)
                        o = {};
                    var d = {};
                    if (o.arrays || o.defaults) {
                        d.parts = [];
                    }
                    if (m.parts && m.parts.length) {
                        d.parts = [];
                        for (var j = 0; j < m.parts.length; ++j) {
                            d.parts[j] = $root.zoom.mail.MIMEPart.toObject(m.parts[j], o);
                        }
                    }
                    return d;
                };

                Children.prototype.toJSON = function toJSON() {
                    return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
                };

                return Children;
            })();

            return MIMEPart;
        })();

        return mail;
    })();

    return zoom;
})();

export { $root as default };
